import React from "react";
import { Answer } from "../../apis";
import { ShortButton } from "../atoms/ShortButton";
import { WideButton } from "../atoms/WideButton";

type Props = {
  options: Array<Option>;
  answerQuestion: (answer: Answer) => Promise<void>;
  initSelect?: Option;
  answerable: boolean;
};

export const NumericChoiceRadio: React.FC<Props> = ({
  options,
  answerQuestion,
  initSelect,
  answerable,
}) => {
  const hanlder = (value: string) => {
    const answer = {
      questionType: "NUMERIC_CHOICE",
      value,
    };

    answerQuestion({ answer });
  };

  const useShortButton = options.length === 2;

  return (
    <>
      {options.map(({ label, value }) =>
        useShortButton ? (
          <ShortButton
            key={value}
            label={label}
            active={value === initSelect?.value}
            onClick={() => hanlder(value)}
            disabled={!answerable}
          />
        ) : (
          <WideButton
            key={value}
            label={label}
            active={value === initSelect?.value}
            onClick={() => hanlder(value)}
            disabled={!answerable}
          />
        )
      )}
    </>
  );
};
